exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 320px) and (max-width: 767px) {\n  main.td-issues .modal {\n    width: 100%; } }\n\nmain.td-issues .td-response-api {\n  padding-top: 12px; }\n  main.td-issues .td-response-api .card {\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0px; }\n    main.td-issues .td-response-api .card .card-title.activator {\n      line-height: 11px; }\n    main.td-issues .td-response-api .card .card-image {\n      height: 300px;\n      background-repeat: no-repeat;\n      background-position: 0% 50%;\n      background-size: cover; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./admin/src/app/components/td-issues/td-issues.component.scss
// module id = 204
// module chunks = 1